import * as THREE from 'three';
import { CAMERA, EYE, FOG } from '../config';

export interface Stage {
  scene: THREE.Scene;
  /** 플레이어 리그. 이걸 움직이면 데스크탑/VR 모두에서 플레이어가 이동한다. */
  dolly: THREE.Object3D;
  camera: THREE.PerspectiveCamera;
}

/**
 * 씬·포그와 dolly→camera 리그를 만든다.
 *
 * 카메라를 dolly의 자식으로 둔다: 로코모션은 dolly 위치를 바꿔서 처리하고,
 * VR에서는 three가 헤드셋 포즈로 camera 행렬을 덮어쓰되 dolly의 부모 변환은
 * 그대로 합성되므로, 같은 리그가 데스크탑/VR 양쪽에서 동작한다.
 */
export function createStage(): Stage {
  const scene = new THREE.Scene();
  scene.fog = new THREE.FogExp2(FOG.color, FOG.density);

  const dolly = new THREE.Object3D();
  scene.add(dolly);

  const camera = new THREE.PerspectiveCamera(
    CAMERA.fov,
    window.innerWidth / window.innerHeight,
    CAMERA.near,
    CAMERA.far,
  );
  camera.position.set(0, EYE, 0);
  camera.rotation.order = 'YXZ'; // yaw(Y) 먼저, pitch(X) 다음 — 1인칭 시점에 적합
  dolly.add(camera);

  return { scene, dolly, camera };
}
